import { showEventDetails } from '../../module/timetable/eventdetails.js';

$(document).ready(function () {
    var picker = $('input[name="datepicker"]');

    $(picker).datetimepicker({
        inline: true,
        todayButton: true,
        timepicker: false,
        dayOfWeekStart: 1,
        onGenerate: function (ct) {
            $(this).find('.xdsoft_date.xdsoft_weekend').addClass('xdsoft_disabled');
            $(this).find('.xdsoft_prev').attr('aria-label', 'To previous month');
            $(this).find('.xdsoft_today_button').attr('aria-label', 'To todays date');
            $(this).find('.xdsoft_next').attr('aria-label', 'To next month');
        },
        onChangeDateTime: function (date) {
            $('#timetable').timetable('changeDate', dayjs(date).toISOString());
        },
    });

    if (typeof ajaxeventsurl !== 'undefined') {
        $('#timetable').timetable({ eventsurl: ajaxeventsurl,
            templateurl: eventsurltemplate,
            onClick: function (calEvent) {
                showEventDetails(calEvent);
            },
            dpy: 0,
        });
    }

    // Click action on the ACYR picker
    $('.acyr-picker').on('click', function (e) {
        e.preventDefault();
        $(this).parent('.btn-group').siblings().find('.btn').removeClass('active');
        $(this).addClass('active');

        // Grab the selected value
        var newacyr = parseInt($(this).data('acyr'));

        // Grab the current date
        var currdate = $(picker).val(); // This is getting "invalid date from somewhere..."
        var mcurrdate = dayjs(currdate + '/01/01', DATE_PICKER_FORMAT);

        // If this is before July, it actually relates to acyr-1
        if (mcurrdate.month() < 7) {
            newacyr += 1;
        }

        // Set the year
        mcurrdate.year(newacyr);

        // Set the date
        $(picker).datetimepicker({ value: mcurrdate.format(DATE_TIME_PICKER_FORMAT) });
        $(picker).val(mcurrdate.format(DATE_PICKER_FORMAT));
    });

    // Define a flag to track if the upload learning resources button has been clicked
    var staffActionResourcesClicked = false;

    // Log when the learning resources button has been clicked
    $('#btnStaffActionResources').on('mousedown', function () {
        staffActionResourcesClicked = true;
    });

    // Log when the learning resources button has been hit with enter button
    $('#btnStaffActionResources').on('keydown', function (event) {
        if (event.which === 13) {
            staffActionResourcesClicked = true;
        }
    });

    // On close of event details modal, refresh timetable if the upload learning resources button was clicked
    $('.closeEventModal').on('click', function () {
        if (staffActionResourcesClicked === true) {
            $('#timetable').timetable('refreshTimetable');
            staffActionResourcesClicked = false;
        }
    });

    // Bind onto the programme year selector to change the data source
    $('.pyr').on('click', function () {
        // Get year to change to
        var newdpy = $(this).attr('data-value');

        // Set the print dialog year value
        $('#print-dialog-year').val(newdpy);
        $(this).parent('.btn-group').siblings().find('.btn').removeClass('active');
        $(this).addClass('active');
        // Reset select user
        $('.selectuser').select2('val', 'Select User');
        // Update the timetable with the new data
        $('#timetable').timetable('changeDegreeYear', newdpy);
    });

    // On change action for the student selector
    $('.selectuser').on('change', function () {
        var selecteduser = $(this).find(':selected').val();
        if (selecteduser !== undefined) {
            $('#timetable').timetable('changeUserView', selecteduser);
        }
    });

    // Stop propagating events for touch events on dropdown menus
    $('body').on('touchstart.dropdown', '.dropdown-menu', function (e) {
        e.stopPropagation();
    });

    // Get all students
    $('#searchbyuser').select2({
        width: '100%',
        theme: 'bootstrap',
        minimumInputLength: 3,
        ajax: {
            url: base_url + 'timetable/ajax_usertosearch',
            dataType: 'json',
            delay: 250,
            type: 'GET',
            data: function (params) {
                var queryParameters = {
                    term: params.term,
                };
                return queryParameters;
            },
            processResults: function (data) {
                return {
                    results: $.map(data, function (item) {
                        var name_email = '';
                        if (item.type == 1) {
                            name_email = item.name + ' (' + item.email + ')';
                        }
                        return {
                            title: name_email,
                            id: item.id,
                            text: name_email,
                        };
                    }),
                };
            },
        },
        templateSelection: function (item) {
            return item.text;
        },
    });
});
